import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faChevronRight, faMinus } from '@fortawesome/pro-regular-svg-icons';
import { IconProp } from '@fortawesome/fontawesome-svg-core';
import Breadcrumbs from '../../components/Breadcrumbs';
import DefaultLayout from '../../layouts/DefaultLayout';
import Container from '../../components/ui/Container';
import Panel from '../../components/ui/Panel';
import { Link } from '../../components/ui/Link';

const breadcrumbLinks = [
  { name: 'Home', linkTo: '/' },
  { name: 'Voorwaarden reviews', linkTo: '/home/voorwaardenbeoordeling' },
];

export const ReviewRulesPage: React.FC = () => (
  <DefaultLayout breadcrumbs={<Breadcrumbs links={breadcrumbLinks} />}>
    <Container state="defaultLayoutFirst">
      <Panel className="w-full md:w-2/3" position="last">
        <div>
          <h1 className="text-blue-900 text-[32px] font-avantgarde font-bold mb-[20px]">
            Voorwaarden reviews
          </h1>
        </div>
        <div className="mb-[24px]">
          <h2 className="font-roboto text-[16px] text-stone-800 font-bold mb-[10px]">
            Wat gebeurt er met jouw review nadat je hem hebt geplaatst?
          </h2>
          <p className="text-stone-800 text-[16px] font-roboto font-normal">
            <div className="grid grid-cols-[1fr_116fr] mb-[10px]">
              <span>
                <FontAwesomeIcon
                  icon={faMinus as IconProp}
                  className="mr-3"
                  color="#B2CADE"
                />
              </span>
              <div>
                De review wordt zichtbaar voor andere bezoekers van
                Advieskeuze en de dienstverlener.
              </div>
            </div>
            <div className="grid grid-cols-[1fr_116fr] mb-[10px]">
              <span>
                <FontAwesomeIcon
                  icon={faMinus as IconProp}
                  className="mr-3"
                  color="#B2CADE"
                />
              </span>
              <div>De review kan gedeeld worden op social media.</div>
            </div>
            <div className="grid grid-cols-[1fr_116fr] mb-[10px]">
              <span>
                <FontAwesomeIcon
                  icon={faMinus as IconProp}
                  className="mr-3"
                  color="#B2CADE"
                />
              </span>
              <div>De review kan zichtbaar worden op partnerwebsites.</div>
            </div>
            <div className="grid grid-cols-[1fr_116fr]">
              <span>
                <FontAwesomeIcon
                  icon={faMinus as IconProp}
                  className="mr-3"
                  color="#B2CADE"
                />
              </span>
              <div>
                De review kan door Advieskeuze verwijderd worden van
                Advieskeuze en partnerwebsites.
              </div>
            </div>
          </p>
        </div>
        <div className="">
          <h2 className="font-roboto text-[16px] text-stone-800 font-bold mb-[10px]">
            Wat gebeurt er met jouw review nadat je hem hebt geplaatst?
          </h2>
          <p className="text-stone-800 text-[16px] font-roboto font-normal">
            <div className="grid grid-cols-[1fr_116fr] mb-[10px]">
              <span>
                <FontAwesomeIcon
                  icon={faMinus as IconProp}
                  className="mr-3"
                  color="#B2CADE"
                />
              </span>
              <div>
                Advieskeuze helpt zoveel mogelijk klanten op het eigen
                platform en op partnerwebsites bij het zoeken van de juiste
                dienstverlener. Reviews verschijnen daarom niet alleen op
                Advieskeuze, maar ook op aangesloten partnerwebsites.
              </div>
            </div>
            <div className="grid grid-cols-[1fr_116fr] mb-[10px]">
              <span>
                <FontAwesomeIcon
                  icon={faMinus as IconProp}
                  className="mr-3"
                  color="#B2CADE"
                />
              </span>
              <div>
                Bezoeker van Advieskeuze kunnen reviews delen via
                Facebook, Twitter, Google PLUS en LinkedIn.
              </div>
            </div>
            <div className="grid grid-cols-[1fr_116fr] mb-[10px]">
              <span>
                <FontAwesomeIcon
                  icon={faMinus as IconProp}
                  className="mr-3"
                  color="#B2CADE"
                />
              </span>
              <div>
                Dienstverleners kunnen (eenmalig) op een review op
                Advieskeuze reageren.
              </div>
            </div>
            <div className="grid grid-cols-[1fr_116fr] mb-[10px]">
              <span>
                <FontAwesomeIcon
                  icon={faMinus as IconProp}
                  className="mr-3"
                  color="#B2CADE"
                />
              </span>
              <div>
                Naast de review plaatsen we de gebruikersnaam,
                plaatsingsdatum, omschrijving en (een deel van de) motivatie
                door.
              </div>
            </div>
            <div className="grid grid-cols-[1fr_116fr] mb-[10px]">
              <span>
                <FontAwesomeIcon
                  icon={faMinus as IconProp}
                  className="mr-3"
                  color="#B2CADE"
                />
              </span>
              <div>
                Advieskeuze plaatst alleen reviews die aan de{' '}
                <span className="underline text-blue-500">
                  <a href="/home/spelregelsbeoordeling">spelregels</a>
                </span>{' '}
                voldoen. Als een review hier niet aan voldoet behoudt
                Advieskeuze zich het recht voor de review te verwijderen.
                Je wordt hiervan per e-mail op de hoogte gesteld.
              </div>
            </div>
            <div className="grid grid-cols-[1fr_116fr] mb-[10px]">
              <span>
                <FontAwesomeIcon
                  icon={faMinus as IconProp}
                  className="mr-3"
                  color="#B2CADE"
                />
              </span>
              <div>
                Wil jij dat jouw review van Advieskeuze wordt verwijderd?
                Stuur dan een mail naar info@advieskeuze.nl.
              </div>
            </div>
            <div className="grid grid-cols-[1fr_116fr]">
              <span>
                <FontAwesomeIcon
                  icon={faMinus as IconProp}
                  className="mr-3"
                  color="#B2CADE"
                />
              </span>
              <div>
                Advieskeuze is niet aansprakelijk voor de inhoud van een
                review of eventuele schade veroorzaakt door het geven van
                een review.
              </div>
            </div>
          </p>
          <Link
            variant="default"
            title="Lees ook ons reviewbeleid"
            href={`/home/reviewbeleid`}
            className="mt-6"
          >
            <FontAwesomeIcon icon={faChevronRight as IconProp} />
            Lees ook ons reviewbeleid
          </Link>
        </div>
      </Panel>
    </Container>
  </DefaultLayout>
);
